import { DataQualityFlag } from './account-usage.model';
import { AccountSubscriptionDto } from './subscription.model';
import { PlanDto } from './plan.model';

/** Feature de plan que habilita la generación de documentos (Generar / Documentos Generados). */
export const DOC_GENERATION_FEATURE_CODE = 'doc_generation';

/** R3: lifecycle de resúmenes generados (Pro+: estados, tabs y enviar a revisión). */
export const GENERATED_DOCS_LIFECYCLE_FEATURE_CODE = 'generated_documents_lifecycle';
/** R3: aprobación/rechazo de resúmenes (Business+). */
export const GENERATED_DOCS_APPROVAL_FEATURE_CODE = 'generated_documents_approval';
/** R3: timeline de auditoría de transiciones (Enterprise). */
export const GENERATED_DOCS_AUDIT_FEATURE_CODE = 'generated_documents_audit';
/** R3: export DOCX de documentos generados (Business+). */
export const GENERATED_DOCS_EXPORT_DOCX_FEATURE_CODE = 'generated_documents_export_docx';

/** R3.5: versionado de documentos de ingesta (Pro+: badge vN + historial de versiones). */
export const DOC_VERSIONING_FEATURE_CODE = 'doc_versioning';

/** R4: Knowledge Hub (Business+: sección propia /knowledge — entidades, timeline y vencimientos). */
export const KNOWLEDGE_HUB_FEATURE_CODE = 'knowledge_hub';
export const CHANGE_DETECTION_FEATURE_CODE = 'change_detection';

/** R6: bandeja de alertas de conocimiento (sección propia /alerts). Nace OFF. */
export const KNOWLEDGE_ALERTS_FEATURE_CODE = 'knowledge_alerts';
/** R6: dashboard de conocimiento read-only (/dashboards/knowledge). Nace OFF. */
export const ALERT_DASHBOARD_FEATURE_CODE = 'alert_dashboard';

/** Resultado (dry-run) de POST accounts/{accountId}/entitlements/evaluate. */
export interface EntitlementEvaluationDto {
  accountId: number;
  subscriptionStatus: string | null;
  planCode: string | null;
  allowed: boolean;
  decision: string;
  dataQuality: DataQualityFlag[];
}

export interface EffectiveAccountPlanDto {
  accountId: number;
  hasActiveSubscription: boolean;
  subscriptionStatus: string | null;
  planCode: string | null;
  plan: PlanDto | null;
  subscription: AccountSubscriptionDto | null;
  dataQuality: DataQualityFlag[];
}
